import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import {
  LoginWorker, LoginCompany, HireTrainer, LoginTrainer, HirePlans, ForgotPassword, typePlans, LoginBaseWithButtons, LoginStudent,
} from '../screens/login';

const Login = createStackNavigator();
const LoginNavigator = () => (
  <Login.Navigator screenOptions={screenOptions}>
    <Login.Screen name="Base" component={LoginBaseWithButtons} />
    <Login.Screen name="Login Worker" component={LoginWorker} />
    <Login.Screen name="Login Company" component={LoginCompany} />
    <Login.Screen name="Login Student" component={LoginStudent} />
    <Login.Screen name="Hire Trainer" component={HireTrainer} />
    <Login.Screen name="Login Trainer" component={LoginTrainer} />
    <Login.Screen name="Hire Plans" component={HirePlans} />
    <Login.Screen name="Esqueci Minha Senha" component={ForgotPassword} />
    <Login.Screen name="Planos" component={typePlans} />
  </Login.Navigator>
);

export default LoginNavigator;
